import Service from './abstract';

class Currencies extends Service {
    constructor () {
        super('currencies');
    }
}

export default new Currencies();
